import {AfterViewInit, Component, NgZone, OnInit} from '@angular/core';
import {ShortUrlService} from "../../providers/short-url.service";
import {LoadingServiceProvider} from "../../providers/loading-service";
import {isNullOrUndefined} from "util";
import {Router} from "@angular/router";
import {ScrollService} from "../../providers/scroll.service";

@Component({
  selector: 'app-puggl-stats',
  templateUrl: './puggl-stats.component.html',
  styleUrls: ['./puggl-stats.component.scss']
})
export class PugglStatsComponent implements OnInit, AfterViewInit {
  stats: any;
  statsArray = [];

  totalShortUrls: number = 0;
  totalClicks: number = 0;
  clickIndexes = [];

  longUrl: string;
  newShortUrl: string;

  public doughnutChartLabels:string[] = [];
  public doughnutChartData:number[] = [];
  public doughnutChartType:string = 'doughnut';
  months = ["Jan", "Feb", "Mar", "Apr", "May",
    "Jun", "Jul", "Aug", "Sep", "Oct",
    "Nov", "Dec"];
  doughnutTmp = {};

  public lineChartData:Array<any> = [
    {data: [], label: 'Number of Clicks'},
  ];
  public lineChartLabels:Array<any> = [];
  public lineChartOptions:any = {
    responsive: true
  };
  public lineChartLegend:boolean = true;
  public lineChartType:string = 'line';

  lineTmp = {};

  public lineChartColors:Array<any> = [
    { // grey
      backgroundColor: '#e1f7d5',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    { // dark grey
      backgroundColor: '#ffbdbd',
      borderColor: 'rgba(77,83,96,1)',
      pointBackgroundColor: 'rgba(77,83,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    },
    { // grey
      backgroundColor: 'rgba(148,159,177,0.2)',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];

  constructor(
    public shortUrl: ShortUrlService,
    public loading: LoadingServiceProvider,
    private router: Router,
    private scroll: ScrollService
  ) { }

  ngOnInit() {
    // this.loading.showLoading();

    if(isNullOrUndefined(this.shortUrl.stats)) {

      this.shortUrl.getStats().toPromise().then((stats) => {
        this.stats = stats;

        this.setData();

        this.loading.hideLoading();
      });
    }
    else {
      this.stats =  [];
      this.stats = this.shortUrl.stats;
      this.statsArray = this.shortUrl.statsArray;
      this.totalShortUrls = this.shortUrl.totalShortUrls;
      this.totalClicks = this.shortUrl.totalClicks;
      this.clickIndexes = this.shortUrl.clickIndexes;
      this.setData();
    }
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
  }

  public chartClicked(e:any):void {
    console.log(e);
  }

  public chartHovered(e:any):void {
    console.log(e);
  }

  generateShortUrl() {
    this.shortUrl.generateShortUrl(this.longUrl).toPromise().then((url) => {
      this.newShortUrl = url.shortUrl;

    });
  }

  setData() {
    this.statsArray = [];
    this.clickIndexes = [];
    this.totalShortUrls = 0;
    this.totalClicks = 0;
    for (let index in this.stats) {
      this.statsArray.push(this.stats[index]);
      this.totalClicks += this.stats[index].numClicks;
      this.totalShortUrls += 1;
      this.clickIndexes.push(index);

      for (let click of this.stats[index].clickData) {
        if (isNullOrUndefined(this.doughnutTmp[click.city + ', ' + click.state])) {
          this.doughnutTmp[click.city + ', ' + click.state] = 1;
        }
        else {
          this.doughnutTmp[click.city + ', ' + click.state] += 1;
        }
        let tmp = new Date(click.clicked_on);

        if (isNullOrUndefined(this.lineTmp[this.months[tmp.getMonth()] + ' ' + tmp.getDate()])) {
          this.lineTmp[this.months[tmp.getMonth()] + ' ' + tmp.getDate()] = 1;
        }
        else {
          this.lineTmp[this.months[tmp.getMonth()] + ' ' + tmp.getDate()] += 1;
        }
      }
    }

    this.shortUrl.stats = this.stats;
    this.shortUrl.statsArray = this.statsArray;
    this.shortUrl.totalShortUrls = this.totalShortUrls;
    this.shortUrl.totalClicks = this.totalClicks;
    this.shortUrl.clickIndexes = this.clickIndexes;


    for (let item in this.lineTmp) {
      this.lineChartLabels.push(item);
      this.lineChartData[0].data.push(this.lineTmp[item]);
    }

    let clone = JSON.parse(JSON.stringify(this.lineChartData));
    this.lineChartData = clone;

    let clone2 = []
    for (let item in this.doughnutTmp) {
      this.doughnutChartLabels.push(item);
      clone2.push(this.doughnutTmp[item])
    }

    this.doughnutChartData = clone2;
  }

  goToLinkGraph(urlId) {
    this.shortUrl.shortLinkStats = this.stats[urlId];
    this.shortUrl.shortLinkUrl = this.stats[urlId].shortUrl;
    this.router.navigate(['short-url-graph']);
  }

}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/puggl-stats/puggl-stats.component.ts